module.exports = __webpack_public_path__ + "media/case2.531ed1cd.mp4";